import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import MicroModal from "micromodal";
import { ArrowDown2 } from "iconsax-reactjs";

import { Tooltippy, PopoverDashboard } from "../../../actions/Tippy";
import TimeCounterInternal from "../../../containers/TimeCounterInternalDash";
import TimeCounterMinute from "../../../containers/TimeCounterMinute";
import TextMedium from "../TextComponent/TextMedium";
import PopoverColumnsFilter from "../../popovercolumnsfilter/PopoverColumnsFilter";
import Table from "../../table";
import TableVirtual from "../../TableVirtual";
import SeeQueue from "../../modals/ModalSeeQueue";
import ModalsDetails from "../../modals/NewModals/index";
import TransferClientModal from "../../../containers/TransferClientModal";
import DeleteCallModal from "../../../modals/DeleteCallModal";

import { connection_platform } from "../../../services/api";

import LoadingTable from "../../../build/images/Column.png";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as ColumnFilterIcon } from "../../../build/images/icons/ColumnFilterIcon.svg";

let columns = [];
// let exhibColumn = [];
let TimeFormat = require("hh-mm-ss");
let colaboratorsDataFiltered = [];
let codeStatus = [];
var port = localStorage.getItem("port");
var pathname = localStorage.getItem("pathname");

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data.toLowerCase();
  const objectRowB = rowB.original[columnId].data.toLowerCase();

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function numberSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data;
  const objectRowB = rowB.original[columnId].data;

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function customSorting(rowA, rowB, columnId) {
  const customRowA = rowA.original[columnId].config.customOrder;
  const customRowB = rowB.original[columnId].config.customOrder;

  if (customRowA > customRowB) return -1;
  if (customRowB > customRowA) return 1;
  return 0;
}

function dateSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder.getTime();
  const dateRowB = rowB.original[columnId].config.customOrder.getTime();

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

function dateTimeSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder;
  const dateRowB = rowB.original[columnId].config.customOrder;

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

const CardTableGroupRow = ({ title }) => {
  const exhibColumn = useSelector((state) => state.columnsgrouprow);
  const usersReduce = useSelector((state) => state.agents);
  const managerStatusOperators = useSelector(
    (state) => state.datamanagerstatusoperators
  );
  const groupsRow = useSelector((state) => state.groupsrow);

  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const GroupsPermissionSupervisor = useSelector(
    (state) => state.grouppermissionsupervisor
  );
  const listCallQueue = useSelector((state) => state.listcallqueue);
  const InfoUsers = useSelector((state) => state.informationusers);

  const [usersRefactored, setUsersRefactored] = useState([]);
  const [queue, setQueue] = useState(false);
  const [infoQueue, setInfoQueue] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState({
    deletecdrid: "",
    deletequeueid: "",
    mediaid: "",
  });
  const [openCard, setOpenCard] = useState(
    localStorage.getItem("managerRowsOpenCard")
      ? localStorage.getItem("managerRowsOpenCard") === "true"
      : true
  );
  const [shouldRender, setShouldRender] = useState(openCard);

  const dispatch = useDispatch();
  let dataoperators = managerStatusOperators
    ? JSON.parse(JSON.stringify(managerStatusOperators))
    : "";

  function chooseDisplay(nameDisplay) {
    const indexFind = exhibColumn.findIndex(
      (column) => column.title.toLowerCase() === nameDisplay.toLowerCase()
    );

    return exhibColumn[indexFind].exhib;
  }

  const renderRow = (qtdefila, queue) => {
    return (
      <div
        className="manager-box-status"
        style={{ cursor: qtdefila > 0 ? "pointer" : "auto" }}
        onClick={() => {
          if (qtdefila > 0) {
            setQueue(queue);
            MicroModal.show("modal__seeQueues");
          }
        }}
      >
        <div className="manager-box-status__circle green"></div>
        <span>{qtdefila}</span>
      </div>
    );
  };

  function createJson(item) {
    if (item) {
      let mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        let obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  const calculateTime = (date) => {
    let duracao = 0;
    let arrayCompA = date;
    let datatimeCompA = moment().format("YYYY/MM/DD HH:mm:ss");
    let dataStatusA = moment(arrayCompA, "DD/MM/YYYY HH:mm:ss").format(
      "YYYY/MM/DD HH:mm:ss"
    );

    var valorDiferenca = parseInt(
      Math.abs(Math.round(LoginCompleteReducer.difftime))
    );

    if (parseInt(LoginCompleteReducer.difftime) < 0) {
      datatimeCompA = moment()
        .subtract(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    } else {
      datatimeCompA = moment()
        .add(valorDiferenca, "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }

    duracao = moment(datatimeCompA).diff(dataStatusA, "seconds");
    duracao = duracao < 0 ? 0 : duracao;
    return duracao;
  };

  const convertDays = (totalSeconds) => {
    const secondsInDay = 86400;
    const days = Math.floor(totalSeconds / secondsInDay);

    return days;
  };

  useEffect(() => {
    port = localStorage.getItem("port");
    pathname = localStorage.getItem("pathname");
  }, []);

  useEffect(() => {
    if (infoQueue) {
      MicroModal.show("modal__transferir__chamada");
    }
  }, [infoQueue]);

  useEffect(() => {
    let data = [];
    let groupsPermission = [];
    if (FiltersManager.is_active) {
      let beforeIsFilter = groupsRow;

      beforeIsFilter = beforeIsFilter.filter((filter) =>
        FiltersManager.filter_manager_grouprow.includes(filter.idgrupofila)
      );

      for (const user of beforeIsFilter) {
        let listCall = [];

        let subServices = JSON.parse(user.idsubservico);
        let servicesChange = subServices.map((sub) => sub.id_resposta);

        listCall.push(...servicesChange);

        let listRowQueue = listCallQueue.filter(
          (call) => parseInt(call.status) === 1
        );

        let listQueue = listRowQueue.filter((call) =>
          listCall.includes(call.serviceinid)
        );

        listQueue = listQueue.filter((call) =>
          FiltersManager.filter_manager_channel.includes(call.mediaid)
        );

        let duracaofila = "00:00:00";
        let diasfila = "0";
        let duracaofilamaior = "00:00:00";
        let diasfilamaior = "0";
        let duracaodisponivel = "00:00:00";
        let duracaoativos = "00:00:00";
        let duracaopausas = "00:00:00";
        let colortime = "#757575";

        if (!connection_platform.changeRowQueueDashboard) {
          if (listQueue.length > 0) {
            let higherTemp = "";
            const formatTimeAll = listQueue.map((msg) => {
              let timeCalculate = calculateTime(msg.to_char);

              if (timeCalculate > higherTemp) {
                higherTemp = timeCalculate;
              }

              return timeCalculate;
            });
            duracaofila =
              formatTimeAll.reduce((a, b) => a + b) / listQueue.length;
            diasfila = convertDays(duracaofila);

            if (higherTemp) {
              duracaofilamaior = higherTemp;
              diasfilamaior = convertDays(duracaofilamaior);
            }
          }
          if (user.mtdisponivel) {
            duracaodisponivel = calculateTime(
              user.mtdisponivel.replaceAll("-", "/")
            );
          }
          if (user.mtsaida) {
            duracaoativos = calculateTime(user.mtsaida.replaceAll("-", "/"));
          }
          if (user.mtpausado) {
            duracaopausas = calculateTime(user.mtpausado.replaceAll("-", "/"));
          }

          data.push({
            group: {
              data: (
                <Tooltippy content={user.nomegrupofila}>
                  {
                    <>
                      <span className="manager-box-status__text more-width">
                        {user.nomegrupofila}
                      </span>
                    </>
                  }
                </Tooltippy>
              ),
              config: {
                textEllipsis: true,
                className: "cell-blue-text",
                customOrder: user.nomegrupofila,
              },
            },
            row: {
              data: renderRow(listQueue.length, user),
              config: {
                className: "",
                customOrder: listQueue.length,
              },
            },
            timerow: {
              data:
                listQueue.length > 0 ? (
                  <TimeCounterMinute
                    horario={parseInt(duracaofila)}
                    key={user.idgrupofila + user.nomegrupofila + duracaofila}
                    maxTime={InfoUsers.tmsdashboard.medtimerow}
                    day={diasfila}
                  />
                ) : (
                  duracaofila
                ),
              config: {
                textEllipsis: true,
                customOrder: new Date(user.mtfila),
              },
            },
            timehighrow: {
              data:
                listQueue.length > 0 ? (
                  <TimeCounterMinute
                    horario={parseInt(duracaofilamaior)}
                    key={
                      user.idgrupofila + user.nomegrupofila + duracaofilamaior
                    }
                    maxTime={InfoUsers.tmsdashboard.maxtimerow}
                    day={diasfilamaior}
                  />
                ) : (
                  duracaofilamaior
                ),
              config: {
                textEllipsis: true,
                customOrder: new Date(user.mtfila),
              },
            },
            connected: {
              data: user.qtdelogados,
              config: {
                className: "cell-gray-text",
              },
            },
            received: {
              data: user.qtde_recebidas,
              config: {
                className: "cell-gray-text",
              },
            },
            abandoned: {
              data: user.qtde_abandonada,
              config: {
                className: "cell-gray-text",
              },
            },
            totalAvailable: {
              data: user.qtdedisponiveis,
              config: {
                className: "cell-gray-text",
                cellColor: "green-cell",
              },
            },
            longerTimeAv: {
              data: user.mtdisponivel ? (
                <TimeCounterInternal
                  horario={parseInt(duracaodisponivel)}
                  key={
                    user.idgrupofila + user.nomegrupofila + duracaodisponivel
                  }
                />
              ) : (
                duracaodisponivel
              ),
              config: {
                cellColor: "green-cell",
                textEllipsis: true,
                customOrder: new Date(user.mtdisponivel),
              },
            },
            activeTotal: {
              data: user.qtdesaida,
              config: {
                className: "cell-gray-text",
                cellColor: "blue-cell",
              },
            },
            longerTimeAc: {
              data: user.mtsaida ? (
                <TimeCounterInternal
                  horario={parseInt(duracaoativos)}
                  key={user.idgrupofila + user.nomegrupofila + duracaoativos}
                />
              ) : (
                duracaoativos
              ),
              config: {
                textEllipsis: true,
                customOrder: new Date(user.mtsaida),
                cellColor: "blue-cell",
              },
            },
            pauseTotal: {
              data: user.qtdepausados,
              config: {
                className: "cell-gray-text",
                cellColor: "yellow-cell",
              },
            },
            longerTimeP: {
              data: user.mtpausado ? (
                <TimeCounterInternal
                  horario={parseInt(duracaopausas)}
                  key={user.idgrupofila + user.nomegrupofila + duracaopausas}
                />
              ) : (
                duracaopausas
              ),
              config: {
                textEllipsis: true,
                customOrder: new Date(user.mtpausado),
                cellColor: "yellow-cell",
              },
            },
            csat: {
              data: user.csat ? `${user.csat}%` : "-",
              config: {
                className: "",
              },
            },
          });
        } else {
          if (listQueue.length > 0) {
            let higherTemp = "";
            const formatTimeAll = listQueue.map((msg) => {
              let timeCalculate = calculateTime(msg.to_char);

              if (timeCalculate > higherTemp) {
                higherTemp = timeCalculate;
              }
            });

            if (higherTemp) {
              duracaofilamaior = higherTemp;
              diasfilamaior = convertDays(duracaofilamaior);
            }
            // duracaofila = calculateTime(user.mtfila.replaceAll("-", "/"));
          }
          data.push({
            group: {
              data: (
                <Tooltippy content={user.nomegrupofila}>
                  {
                    <>
                      <span className="manager-box-status__text more-width">
                        {user.nomegrupofila}
                      </span>
                    </>
                  }
                </Tooltippy>
              ),
              config: {
                textEllipsis: true,
                className: "cell-blue-text",
                customOrder: user.nomegrupofila,
              },
            },
            row: {
              data: renderRow(listQueue.length, user),
              config: {
                className: "",
                customOrder: listQueue.length,
              },
            },
            timehighrow: {
              data:
                listQueue.length > 0 ? (
                  <TimeCounterMinute
                    horario={parseInt(duracaofilamaior)}
                    key={
                      user.idgrupofila + user.nomegrupofila + duracaofilamaior
                    }
                    maxTime={InfoUsers.tmsdashboard.maxtimerow}
                    day={diasfilamaior}
                  />
                ) : (
                  duracaofilamaior
                ),
              config: {
                textEllipsis: true,
                customOrder: new Date(user.mtfila),
              },
            },
            received: {
              data: user.qtde_recebidas,
              config: {
                className: "cell-gray-text",
              },
            },
            abandoned: {
              data: user.qtde_abandonada,
              config: {
                className: "cell-gray-text",
              },
            },
            csat: {
              data: user.csat ? `${user.csat}%` : "-",
              config: {
                className: "",
              },
            },
          });
        }
      }
      colaboratorsDataFiltered = data;
      setUsersRefactored(data);
    }
  }, [
    groupsRow,
    FiltersManager,
    GroupsPermissionSupervisor,
    managerStatusOperators,
    listCallQueue,
  ]);

  useEffect(() => {
    let timeoutId;
    if (openCard) {
      setShouldRender(true);
    } else {
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, 400);
    }
    localStorage.setItem("managerRowsOpenCard", openCard);
    return () => clearTimeout(timeoutId);
  }, [openCard]);

  columns = !connection_platform.changeRowQueueDashboard
    ? [
        {
          Header: "Grupo",
          accessor: "group",
          Hint: "Grupo",
          id: "group",
          sortType: customSorting,
          disableFilters: true,
          display: chooseDisplay("Grupo"),
        },
        {
          Header: "Fila",
          accessor: "row",
          Hint: "Fila",
          id: "row",
          disableFilters: true,
          sortType: customSorting,
          display: chooseDisplay("Fila"),
          // disableSortBy: true,
        },
        {
          Header: "Tempo de fila",
          accessor: "timerow",
          Hint: "Tempo de fila",
          id: "timerow",
          disableFilters: true,
          sortType: dateTimeSorting,
          display: chooseDisplay("Tempo de fila"),
        },
        {
          Header: "Maior T. de fila",
          accessor: "timehighrow",
          Hint: "Maior tempo de fila",
          id: "timehighrow",
          disableFilters: true,
          sortType: dateTimeSorting,
          display: chooseDisplay("Maior T. de fila"),
        },
        {
          Header: "Logados",
          accessor: "connected",
          Hint: "Logados",
          id: "connected",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Logados"),
        },
        {
          Header: "Recebidas",
          accessor: "received",
          Hint: "Recebidas",
          id: "received",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Recebidas"),
        },
        {
          Header: "Abandonadas",
          accessor: "abandoned",
          Hint: "Abandonadas",
          id: "abandoned",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Abandonadas"),
        },
        {
          Header: "Total Disponível",
          accessor: "totalAvailable",
          Hint: "Total Disponível",
          id: "totalAvailable",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Total Disponível"),
        },
        {
          Header: "Maior tempo",
          accessor: "longerTimeAv",
          Hint: "Maior tempo",
          id: "longerTimeAv",
          disableFilters: true,
          sortType: dateTimeSorting,
          display: chooseDisplay("Maior tempo Disponível"),
        },
        {
          Header: "Total Ativos",
          accessor: "activeTotal",
          Hint: "Total Ativos",
          id: "activeTotal",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Total Ativos"),
        },
        {
          Header: "Maior tempo",
          accessor: "longerTimeAc",
          Hint: "Maior tempo",
          id: "longerTimeAc",
          disableFilters: true,
          sortType: dateTimeSorting,
          display: chooseDisplay("Maior tempo Ativos"),
        },
        {
          Header: "Total Pausados",
          accessor: "pauseTotal",
          Hint: "Total Pausados",
          id: "pauseTotal",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Total Pausados"),
        },
        {
          Header: "Maior tempo",
          accessor: "longerTimeP",
          Hint: "Maior tempo",
          id: "longerTimeP",
          disableFilters: true,
          sortType: dateTimeSorting,
          display: chooseDisplay("Maior tempo Pausas"),
        },
        {
          Header: "CSAT",
          accessor: "csat",
          Hint: "CSAT",
          id: "csat",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("CSAT"),
        },
      ]
    : [
        {
          Header: "Grupo",
          accessor: "group",
          Hint: "Grupo",
          id: "group",
          sortType: customSorting,
          disableFilters: true,
          display: chooseDisplay("Grupo"),
        },
        {
          Header: "Fila",
          accessor: "row",
          Hint: "Fila",
          id: "row",
          disableFilters: true,
          sortType: customSorting,
          display: chooseDisplay("Fila"),
          // disableSortBy: true,
        },
        {
          Header: "Maior T. de fila",
          accessor: "timehighrow",
          Hint: "Maior tempo de fila",
          id: "timehighrow",
          disableFilters: true,
          sortType: dateTimeSorting,
          display: chooseDisplay("Maior T. de fila"),
        },
        {
          Header: "Recebidas",
          accessor: "received",
          Hint: "Recebidas",
          id: "received",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Recebidas"),
        },
        {
          Header: "Abandonadas",
          accessor: "abandoned",
          Hint: "Abandonadas",
          id: "abandoned",
          disableFilters: true,
          sortType: numberSorting,
          display: chooseDisplay("Abandonadas"),
        },
        {
          Header: "CSAT",
          accessor: "csat",
          Hint: "CSAT",
          id: "csat",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("CSAT"),
        },
      ];

  let checkSort = localStorage.getItem("sortMarkedGroupRow")
    ? JSON.parse(localStorage.getItem("sortMarkedGroupRow"))
    : "";

  let sortBy = {
    sortBy: [],
  };

  if (checkSort !== "") {
    sortBy = {
      sortBy: [
        {
          id: checkSort ? checkSort.sort : "agent",
          desc: checkSort ? checkSort.sortDesc : false,
        },
      ],
    };
  }

  return (
    <div
      className={`manager-component__card-table__operators ${
        !openCard ? "close-card" : ""
      }`}
    >
      <div className="manager-component__card-table__box more-space">
        <div
          className="manager-component__card-table__title"
          onClick={() => setOpenCard((open) => !open)}
        >
          <ArrowDown2
            color={openCard ? "#757575" : "#455cc7"}
            style={{ transform: openCard ? "rotate(180deg)" : "rotate(0deg)" }}
          />
          <TextMedium text={title} color={openCard ? "gray" : "blue"} />
        </div>
        {shouldRender && (
          <PopoverColumnsFilter
            className={"filters-columns"}
            placement="bottom-end"
            menuData={exhibColumn}
            screen="manager_groupRow"
          >
            <div className="email__container-subheader__actionsTwo">
              <ColumnFilterIcon />
              <span className="email__container-subheader__actionsTwo-span">
                Colunas
              </span>
            </div>
          </PopoverColumnsFilter>
        )}
      </div>
      {shouldRender && (
        <div className="manager-component__card-table__area operators-manager">
          {LoginCompleteReducer.isLoginComplete ? (
            colaboratorsDataFiltered.length !== 0 ? (
              <TableVirtual
                className="table-groupRow"
                data={colaboratorsDataFiltered}
                columns={columns}
                fixedHeader
                // fixedFirstColumn
                // filtersActive={filtersActive}
                // emptyState={emptyState}
                // setEmptyState={setEmptyState}
                initialState={sortBy}
                screen="manager_groupRow"
                rowShadowLine
              />
            ) : (
              // <Table
              //   className="table-groupRow"
              //   data={colaboratorsDataFiltered}
              //   columns={columns}
              //   fixedHeader
              //   // fixedFirstColumn
              //   // filtersActive={filtersActive}
              //   // emptyState={emptyState}
              //   // setEmptyState={setEmptyState}
              //   initialState={sortBy}
              //   screen="manager_groupRow"
              //   rowShadowLine
              // />
              <div className="manager-component__card-table__area-empty">
                <EmptyState />
              </div>
            )
          ) : (
            <img src={LoadingTable} alt="loading" />
          )}
        </div>
      )}
      <SeeQueue
        queue={queue}
        setQueue={setQueue}
        setInfoQueue={setInfoQueue}
        setDelete={setDeleteInfo}
      />

      <ModalsDetails.NewAnotationModal />

      <ModalsDetails.NewMessageFavoriteModal />

      <ModalsDetails.NewFileShareModal />

      <ModalsDetails.InteractionsHistoricModal />

      {infoQueue && (
        <TransferClientModal
          dashboardQueue={true}
          infoQueue={infoQueue}
          setMonitorDash={setInfoQueue}
        />
      )}

      <DeleteCallModal
        deletecdrid={deleteInfo.deletecdrid}
        deletequeueid={deleteInfo.deletequeueid}
        mediaid={deleteInfo.mediaid}
      />
    </div>
  );
};

export default React.memo(CardTableGroupRow);
